import styled from '@emotion/styled';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BodyTextMedium, HeadingText40, pxToRem, Button } from '@modernhealth/vital-components';
import mobileAppIllustration from 'src/public/ds/illustrations/mobile-app-illustration.svg';
import { Modal } from 'src/shared/components/Modal';

const StyledModal = styled(Modal)({
    '.ant-modal-content': {
        borderRadius: pxToRem(20),

        '.ant-modal-body': {
            display: 'flex',
            flexFlow: 'column',
            alignItems: 'center',
            padding: pxToRem(32),
        },

        '.ant-modal-close': {
            top: pxToRem(4),
            right: pxToRem(4),
        },

        '[class*="Button"]': {
            width: '100%',
        },
    },
});

const MobileAppIllustration = styled('img')({
    width: pxToRem(215),
    height: pxToRem(130),
    marginTop: pxToRem(24),
});

export enum ChatInfoMobileSendLinkModalTestID {
    Wrapper = 'ChatInfoMobileSendLinkModal.Wrapper',
    CloseButton = 'ChatInfoMobileSendLinkModal.CloseButton',
}

interface ChatInfoMobileSendLinkModalProps {
    visible: boolean;
    onSendLinkClick: () => void;
    onClose: () => void;
}

export const ChatInfoMobileSendLinkModal: FC<ChatInfoMobileSendLinkModalProps> = ({
    visible,
    onSendLinkClick,
    onClose,
}) => {
    const { t } = useTranslation();

    return (
        <StyledModal
            visible={visible}
            width={558}
            centered
            footer={null}
            onCancel={onClose}
            closeButtonTestID={ChatInfoMobileSendLinkModalTestID.CloseButton}
            wrapProps={{
                'data-testid': ChatInfoMobileSendLinkModalTestID.Wrapper,
            }}
        >
            <MobileAppIllustration
                src={mobileAppIllustration}
                alt="Person holding smartphone with notification"
            />
            <HeadingText40 marginTop={16} marginBottom={16} centered>
                {t('chatInfoModal.mobileInfo.title')}
            </HeadingText40>
            <BodyTextMedium fontColor="gray65" marginBottom={24} centered>
                {t('chatInfoModal.mobileInfo.description')}
            </BodyTextMedium>
            <Button onClick={onSendLinkClick} size="large" fluid>
                {t('chatInfoModal.mobileInfo.sendLink')}
            </Button>
        </StyledModal>
    );
};
